// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"EditorPlaceholder_placeholder__1UvAG"};